/*
自适应宽or高的图片组件
https://medium.com/@hepiska/react-native-auto-scale-image-fee562fdbf48
*/

import React, { useState, useEffect, memo } from 'react';

import { ImageProps } from 'react-native';
import Image, { getSize } from '@kds/image';

interface ImageType extends ImageProps {
    width?: number;
    height?: number;
    handleError?: (error: Error) => void;
}

const ImageAutoScale = memo(({ source, width, style, handleError, height, ...props }: ImageType) => {
    const [dim, setDim] = useState(null) as any;
    let isMounted = true;
    const calculateDimensions = (newWidth: number, newHeight: number) => {
        if (width && height) {
            return setDim({ width, height });
        }
        if (!width && !height) {
            return setDim({ width: newWidth, height: newHeight });
        }
        if (!height) {
            const height = Number(newHeight) ? Math.floor((width as number) * (newHeight / newWidth)) : width;
            return setDim({
                width,
                height,
            });
        }
        if (!width) {
            return setDim({ width: height * (newWidth / newHeight), height });
        }
    };

    useEffect(() => {
        // handle http source image
        if ((source as any).uri) {
            getSize((source as any).uri).then(
                imageSize => {
                    //  stop calculation when component unmouted
                    if (!isMounted) {
                        return;
                    }

                    calculateDimensions(imageSize.width, imageSize.height);
                },
                error => {
                    // handling error
                    if (handleError) {
                        handleError(error);
                    }
                }
            );
        } else if (source) {
            // handle require local image
            const { width: newWidth, height: newHeight } = Image?.resolveAssetSource?.(source) || {};
            //  stop calculation when component unmouted
            if (!isMounted) {
                return;
            }
            calculateDimensions(newWidth, newHeight);
        }
        return () => {
            isMounted = false;
        };
    }, []);

    if (dim) {
        return (
            <Image
                fadeDuration={0}
                source={source}
                style={{ ...(style as object), height: dim.height, width: dim.width }}
                onError={e => {
                    // handling error
                    if (handleError) {
                        handleError(e.nativeEvent.error);
                    }
                }}
                {...props}
            />
        );
    }
    return null;
});

ImageAutoScale.displayName = 'ImageAutoScale';

export default ImageAutoScale;
